export const FILTER_EQUIPMENT_VISIBILITY_OPTIONS = {
  SHOW_ALL: 'showAll',
  ACTIVE_LAST_7_DAYS: 'activeLast7Days'
};
export const FILTER_EQUIPMENT_VISIBILITY_DEFAULT = FILTER_EQUIPMENT_VISIBILITY_OPTIONS
  .ACTIVE_LAST_7_DAYS;

export const FILTER_EQUIPMENT_VISIBILITY_STORAGE_KEY = 'filterEquipmentVisibilityOption';
